import React, { useState } from 'react';
import { phoneRegex } from '../../Helper/Regex';
import { v4 as uuidv4 } from 'uuid';
import { loginUser, RegisterUser, updateDeviceCount, updateTimeStamp } from '../../Firebase/User-fb';
import { doLogin } from '../../Localstorage';
import { useNavigate } from 'react-router-dom';
import { useAccessCard } from '../../ContextProvider/Accesscardprovider';
import { getCurrentTime } from '../../Helper/Calculation';

const CallReg = ({ accessCallReg, accessCard }) => {
    const { setToast } = useAccessCard();
    const [phone, setPhone] = useState({ mobile_number: '', name: '' });
    const navigate = useNavigate();
    const [error, setError] = useState('');

    const handleInputChange = (e, field) => {
        setPhone({ ...phone, [field]: e.target.value });
        if (error) setError('');
    };

    const showToast = (msg, type) => {
        setToast({ message: msg, type });
    };

    const sentOtp = async (e) => {
        e.preventDefault();
        if (!phone.mobile_number.trim()) {
            setError('Phone number is required.');
            return;
        }

        if (!phoneRegex.test(phone.mobile_number)) {
            setError('Please enter a valid phone number.');
            return;
        }
        // const currentTimeStamp = Date.now()
        // console.log(currentTimeStamp)
        
        const userData = await loginUser(phone);
        if (userData.length == 1) {
            console.log(userData[0])
            if (userData[0].device_count == 0) {
                updateDeviceCount(userData, 1);
                updateTimeStamp(userData, Date.now())
                doLogin(userData, userData[0].id, () => {
                    accessCallReg();
                    accessCard();
                    showToast('Login Successful', 'success')
                });
            }else{
                accessCallReg();
                accessCard();
                showToast('User already logged in to another device', 'warning')
            }
        } else {
            const userData =
            {
                name: phone.name,
                mobile_number: phone.mobile_number,
                device_count: 1,
                lastTimeStamp: Date.now()
            }
            const data = await RegisterUser(userData)
            console.log(data)
            if (data) {
                doLogin(data, data[0].id, () => {
                    accessCallReg();
                    accessCard();
                    showToast('User register successful', 'success')
                })
            } else {
                showToast('User registration failed.', 'error');
            }
        }
    };

    return (
        <div>
            <form className='Call-Reg-Form'>
                <h3>Login</h3>
                <div className='Call-Reg-inner-div'>
                    <div className='call-inp'>
                        <label htmlFor="username">Phone number:</label>
                        <br />
                        <input
                            type="number"
                            onChange={(e) => { handleInputChange(e, "mobile_number") }}
                            name="username"
                            className="no-arrows"
                            placeholder="Enter your phone no."
                        />
                        {error && <span className="error">{error}</span>}
                    </div>

                    <div className='call-inp'>
                        <label htmlFor="username">Username:</label>
                        <br />
                        <input
                            type="text"
                            onChange={(e) => { handleInputChange(e, "name") }}
                            name="username"
                            className="no-arrows"
                            placeholder="Enter your username "
                        />
                    </div>
                </div>
                <div className='Call-Reg-Btn'>
                    <button onClick={sentOtp}>Next</button>
                </div>
            </form>
        </div>
    );
};

export default CallReg;
